import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import type { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import BodyView from "@/layout/bodyView.vue";
import indexDashboard from "@/pages/indexDashboard.vue";
import industriesList from "@/pages/pms/admin/industriesList.vue";
import applictaionTypeList from "@/pages/pms/admin/applicationTypeList.vue";
import applictaionUserTypesList from "@/pages/pms/admin/applicationUserTypes.vue";
import projectUserTypes from "@/pages/pms/admin/projectUserTypes.vue";
//import moduleoldList from "@/pages/pms/admin/moduleListOld.vue"
import processTypes from "@/pages/pms/admin/processTypes.vue";
import teamList from "@/pages/pms/admin/teamsList.vue";
import FeaturesList from "@/pages/pms/admin/packages/FeaturesList.vue";
import userlists from "@/pages/pms/admin/userManagements.vue";
import processSteps from "@/pages/pms/admin/processTypesSteps.vue";
import projectCreation from "@/pages/pms/admin/projectCreation.vue";

import cardStatusList from "@/pages/pms/admin/cardstatusesList.vue";
import moduleList from "@/pages/pms/admin/moduleList.vue";
import plateformList from "@/pages/pms/admin/plateformList.vue";
import industryUserList from "@/pages/pms/admin/industryuserList .vue";
import workspaceModuleList from "@/pages/pms/admin/workspacemodulesList.vue";
import cardTypeList from "@/pages/pms/admin/cardtypesList.vue";
import cardPriorityList from "@/pages/pms/admin/cardpriorityList.vue";
import technologiesList from "@/pages/pms/admin/technologiesList.vue";
import jobtitleList from "@/pages/pms/admin/jobtitlesList.vue";
import jobRoleList from "@/pages/pms/admin/rolesList.vue";
import toolsList from "@/pages/pms/admin/toolsList.vue";
import promptList from "@/pages/pms/admin/promptList.vue";
import promptVariableList from "@/pages/pms/admin/promptVariablesList.vue";
import promptCategoriesList from "@/pages/pms/admin/promptCategoryList.vue";
import promptForm from "@/pages/pms/admin/PromptFormNew.vue";
import workspaceDescription from "@/pages/pms/admin/workspaceDescriptionList.vue";
import LaneSuggessions from "@/pages/pms/admin/LaneSuggessions.vue";

import loginPage from "@/pages/pms/admin/loginPage.vue";
import CreateWorkspaceModule from "@/pages/pms/admin/createWorkspaceModule.vue";
import workspaceAgentsList from "@/pages/pms/admin/workspaceAgentsList.vue";
import CreateWorkspaceAgents from "@/pages/pms/admin/createAgents.vue";
import VariableTypes from "@/pages/pms/admin/variableTypes.vue";
import RegisteredUsers from "@/pages/admin/RegisteredUsers.vue";
import UserWorkspaces from "@/pages/admin/UserWorkspaces.vue";
import AllWorkspaces from "@/pages/admin/AllWorkspaces.vue";
import People from "@/pages/pms/admin/People.vue";
import Pin from "@/pages/pms/admin/Pin.vue";
import SheetsList from "@/pages/pms/admin/SheetsList.vue";
import BlogCategoriesList from "@/pages/pms/admin/BlogCategoriesList.vue";
import BlogCategoryEdit from "@/pages/pms/admin/BlogCategoryEdit.vue";
import BlogsList from "@/pages/pms/admin/BlogsList.vue";
import BlogEdit from "@/pages/pms/admin/BlogEdit.vue";
import KnowlegeCategoriesList from "@/pages/pms/admin/KnowlegeCategoriesList.vue";
import KnowlegeCategoryEdit from "@/pages/pms/admin/KnowlegeCategoryEdit.vue";
import KnowlegeList from "@/pages/pms/admin/KnowlegeList.vue";
import KnowlegeEdit from "@/pages/pms/admin/KnowlegeEdit.vue";
import Mindmap from "@/pages/pms/admin/Mindmap.vue";
import PromptFlowsList from "@/pages/pms/admin/PromptFlowsList.vue";
import PackageCategoriesList from "@/pages/pms/admin/packages/PackageCategoriesList.vue";
import CurrenciesList from "@/pages/pms/admin/packages/CurrenciesList.vue";
import PackagesList from "@/pages/pms/admin/packages/PackagesList.vue";
import PaidSubscriptions from "@/pages/pms/admin/subscriptions/PaidSubscriptions.vue"; 
import MarketplaceCategoriesList from "@/pages/pms/admin/MarketplaceCategoriesList.vue";
import ReleaseNotes from "@/pages/pms/admin/ReleaseNotes.vue";
import AgentsList from "@/pages/admin/AgentsList.vue";
import AgentForm from "@/pages/admin/AgentForm.vue";
import AgentDetails from "@/pages/admin/AgentDetails.vue";
import KnowledgeBasesList from "@/pages/admin/KnowledgeBasesList.vue";
import KnowledgeBaseForm from "@/pages/admin/KnowledgeBaseForm.vue";
import KnowledgeBaseDetails from "@/pages/admin/KnowledgeBaseDetails.vue";
import TeamRoleList from "@/pages/pms/admin/TeamRoleList.vue"; 
import FreeSubscriptions from "@/pages/pms/admin/subscriptions/FreeSubscriptions.vue";
import FAQS from "@/pages/pms/admin/FAQS.vue";
import SiteMap from "@/pages/pms/admin/SiteMap.vue";
import Dashboard from "@/pages/pms/admin/Dashboard.vue";
import OpenTickets from "@/pages/pms/admin/OpenTickets.vue";
import ClosedTickets from "@/pages/pms/admin/ClosedTickets.vue";
import SupportTickets from "@/pages/pms/admin/SupportTickets.vue";
import SupportTicketDetail from "@/pages/pms/admin/SupportTicketDetail.vue";
import CMSUsers from "@/pages/pms/admin/CMSUsers.vue";
import CMSRolesAndPermissions from "@/pages/pms/admin/CMSRolesAndPermissions.vue";
import PermissionsModule from "@/pages/pms/admin/PermissionsModule.vue";
import AgentCapabilities from "@/pages/admin/AgentCapabilities.vue";
import AgentRoles from "@/pages/admin/AgentRoles.vue";
import AgentCompetencies from "@/pages/admin/AgentCompetencies.vue";
import AgentRules from "@/pages/admin/AgentRules.vue";
import AgentSkills from "@/pages/admin/AgentSkills.vue";
import AgentLevels from "@/pages/admin/AgentLevels.vue";
import DefaultProcess from "@/pages/pms/admin/DefaultProcess.vue";
import KbCategories from "@/pages/admin/KbCategories.vue";
import AgentActions from "@/pages/admin/AgentActions.vue";
import AgentActionCategories from "@/pages/admin/AgentActionCategories.vue";
import CompaniesList from "@/pages/admin/CompaniesList.vue";
import CompanyDetails from "@/pages/admin/CompanyDetails.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: BodyView,
    meta: {
      title: "Default | Orchit CMS",
    },
    children: [
      {
        path: "/",
        name: "dashboard",
        // component: indexDashboard,
        component: Dashboard,
        meta: {
            title: "Dashboard | Orchit CMS",
        },
      },
      {
        path: "/processsteps",
        name: "processsteps",
        component: processSteps,
        meta: {
          title: "Orchit CMS | process steps",
        },
      },

      {
        path: "/prompt-edit",
        name: "prompt-edit",
        component: promptForm,
        meta: {
          title: "Orchit CMS | Prompt Edit",
        },
      },
      {
        path: "/workspace-descriptions",
        name: "workspace-descriptions",
        component: workspaceDescription,
        meta: {
          title: "Orchit CMS | workspace-descriptions",
        },
      },
      {
        path: "/prompt-create",
        name: "prompt-create",
        component: promptForm,
        meta: {
          title: "Orchit CMS | Prompt Edit",
        },
      },
      {
        path: "/prompt-categories",
        name: "prompt-categories",
        component: promptCategoriesList,
        meta: {
          title: "Orchit CMS | Prompt Categories List",
        },
      },
      {
        path: "/prompt-variables",
        name: "prompt-variables",
        component: promptVariableList,
        meta: {
          title: "Orchit CMS | Prompt Variables List",
        },
      },
      {
        path: "/variables-types",
        name: "variables-types",
        component: VariableTypes,
        meta: {
          title: "Orchit CMS | Variables Type List",
        },
      },
      {
        path: "/prompts",
        name: "job-prompts",
        component: promptList,
        meta: {
          title: "Orchit CMS | Prompt List",
        },
      },
      {
        path: "/job-titles",
        name: "job-titles",
        component: jobtitleList,
        meta: {
          title: "Orchit CMS | Job Titles List",
        },
      },
      {
        path: "/job-roles",
        name: "job-roles",
        component: jobRoleList,
        meta: {
          title: "Orchit CMS | Job Roles List",
        },
      },
      {
        path: "/team-roles",
        name: "team-roles",
        component: TeamRoleList,
        meta: {
          title: "Orchit CMS | Team Roles List",
        },
      }, 
      {
        path: "/tools",
        name: "tools",
        component: toolsList,
        meta: {
          title: "Orchit CMS | Tools List",
        },
      },
      {
        path: "/technologies",
        name: "technologies",
        component: technologiesList,
        meta: {
          title: "Orchit CMS | Technologies List",
        },
      },
      {
        path: "/cardtypes",
        name: "cardtypes",
        component: cardTypeList,
        meta: {
          title: "Orchit CMS | Card Type List",
        },
      },
      {
        path: "/cardpriorities",
        name: "cardpriorities",
        component: cardPriorityList,
        meta: {
          title: "Orchit CMS | Card Priority List",
        },
      },
      {
        path: "/createproject",
        name: "createproject",
        component: projectCreation,
        meta: {
          title: "Orchit CMS | create project",
        },
      },
      {
        path: "/industries",
        name: "industries",
        component: industriesList,
        meta: {
          title: "Orchit CMS | industries",
        },
      },
      {
        path: "/lane-suggestions",
        name: "lane-suggestions",
        component: LaneSuggessions,
        meta: {
          title: "Orchit CMS | Lane Suggestions",
        },
      },
      {
        path: "/userlists",
        name: "userlists",
        component: userlists,
        meta: {
          title: "Orchit CMS | user management",
        },
      },
      {
        path: "/applicationtypes",
        name: "applicationtypes",
        component: applictaionTypeList,
        meta: {
          title: "Orchit CMS | Application Types",
        },
      },
      {
        path: "/applictaionusertypeslist",
        name: "applictaionusertypeslist",
        component: applictaionUserTypesList,
        meta: {
          title: "Orchit CMS | Application User Types",
        },
      },
      {
        path: "/modulelist",
        name: "moduleList",
        component: moduleList,
        meta: {
          title: "Orchit CMS | Modules",
        },
      },
      {
        path: "/workspace-module-list",
        name: "workspace-module-list",
        component: workspaceModuleList,
        meta: {
          title: "Orchit CMS | Workspace Module List",
        },
      },
      {
        path: "/create-workspace-module/:moduleId?",
        name: "create-workspace-module",
        component: CreateWorkspaceModule,
        meta: {
          title: "Orchit CMS | Create Workspace Module",
        },
        props: true,
      },
      {
        path: "/workspace-agents",
        name: "workspace-agents",
        component: workspaceAgentsList,
        meta: {
          title: "Orchit CMS | Workspace Agents",
        },
      },
      {
        path: "/create-workspace-agents/:moduleId?",
        name: "create-workspace-agents",
        component: CreateWorkspaceAgents,
        meta: {
          title: "Orchit CMS | Create Workspace Module",
        },
        props: true,
      },
      {
        path: "/plateformslist",
        name: "plateformList",
        component: plateformList,
        meta: {
          title: "Orchit CMS | Plateforms",
        },
      },
      {
        path: "/industry-users",
        name: "industry-users",
        component: industryUserList,
        meta: {
          title: "Orchit CMS | Industry Users",
        },
      },
      {
        path: "/card-statuses",
        name: "card-statuses",
        component: cardStatusList,
        meta: {
          title: "DATA LISTS | Card Statuses",
        },
      },
      {
        path: "/projectusertypes",
        name: "projectUserTypes",
        component: projectUserTypes,
        meta: {
          title: "Orchit CMS | Project User Types",
        },
      },
      {
        path: "/pro",
        name: "applictaionUserTypesList",
        component: applictaionTypeList,
        meta: {
          title: "Orchit CMS | Application User Types",
        },
      },
      {
        path: "/process",
        name: "processTypes",
        component: processTypes,
        meta: {
          title: "Orchit CMS | Process Types",
        },
      },
      {
        path: "/teams",
        name: "teams",
        component: teamList,
        meta: {
          title: "Orchit CMS | Teams",
        },
      },
      {
        path: "/feature-management",
        name: "feature-management",
        component: FeaturesList,
        meta: {
          title: "Orchit CMS | Feature Management",
        },
      },
      {
        path: "/registered-users",
        name: "registered-users",
        component: RegisteredUsers,
        meta: {
          title: "Orchit CMS | Registered Users",
        },
      },
      {
        path: "/user-workspaces/:userId",
        name: "user-workspaces",
        component: UserWorkspaces,
        meta: {
          title: "Orchit CMS | User Workspaces",
        },
        props: true,
      },
      {
        path: "/all-workspaces",
        name: "all-workspaces",
        component: AllWorkspaces,
        meta: {
          title: "Orchit CMS | All Workspaces",
        },
      },
      {
        path: "/people",
        name: "people",
        component: People,
        meta: {
          title: "Orchit CMS | People",
        },
      },
      {
        path: "/pin",
        name: "pin",
        component: Pin,
        meta: {
          title: "Orchit CMS | Pin",
        },
      },
      {
        path: "/sheets-list",
        name: "sheets-list",
        component: SheetsList,
        meta: {
          title: "Orchit CMS | Sheets",
        },
      },
      {
        path: "/blog-categories",
        name: "blog-categories",
        component: BlogCategoriesList,
        meta: {
          title: "Orchit CMS | Blog Categories",
        },
      },
      {
        path: "/blog-categories/new",
        name: "blog-category-create",
        component: BlogCategoryEdit,
        meta: {
          title: "Orchit CMS | Create Blog Category",
        },
      },
      {
        path: "/blog-categories/:id/edit",
        name: "blog-category-edit",
        component: BlogCategoryEdit,
        meta: {
          title: "Orchit CMS | Edit Blog Category",
        },
        props: true,
      },
      {
        path: "/blogs",
        name: "blogs-list",
        component: BlogsList,
        meta: {
          title: "Orchit CMS | Blogs",
        },
      },
      {
        path: "/blogs/new",
        name: "blog-create",
        component: BlogEdit,
        meta: {
          title: "Orchit CMS | Create Blog",
        },
      },
      {
        path: "/blogs/:id/edit",
        name: "blog-edit",
        component: BlogEdit,
        meta: {
          title: "Orchit CMS | Edit Blog",
        },
        props: true,
      },
      {
        path: "/release-notes",
        name: "release-notes",
        component: ReleaseNotes,
        meta: {
          title: "Orchit CMS | Blogs",
        },
      },
      {
        path: "/knowledge-categories",
        name: "knowledge-categories",
        component: KnowlegeCategoriesList,
        meta: {
          title: "Orchit CMS | Knowledge Categories",
        },
      },
      {
        path: "/knowledge-categories/new",
        name: "knowledge-category-create",
        component: KnowlegeCategoryEdit,
        meta: {
          title: "Orchit CMS | Create Knowledge Category",
        },
      },
      {
        path: "/knowledge-categories/:id/edit",
        name: "knowledge-category-edit",
        component: KnowlegeCategoryEdit,
        meta: {
          title: "Orchit CMS | Edit Knowledge Category",
        },
        props: true,
      },
      {
        path: "/knowledge",
        name: "knowledge-list",
        component: KnowlegeList,
        meta: {
          title: "Orchit CMS | Knowledge Articles",
        },
      },
      {
        path: "/knowledge/new",
        name: "knowledge-create",
        component: KnowlegeEdit,
        meta: {
          title: "Orchit CMS | Create Knowledge Article",
        },
      },
      {
        path: "/knowledge/:id/edit",
        name: "knowledge-edit",
        component: KnowlegeEdit,
        meta: {
          title: "Orchit CMS | Edit Knowledge Article",
        },
        props: true,
      },
      {
        path: "/prompt-flows",
        name: "prompt-flows",
        component: PromptFlowsList,
        meta: {
          title: "Orchit CMS | Prompt Flows",
        },
      },
      {
        path: "/mindmap",
        name: "Mindmap",
        component: Mindmap,
        meta: {
          title: "Orchit CMS | Mindmap",
        },
      },
      {
        path: "/package-categories",
        name: "package-categories",
        component: PackageCategoriesList,
        meta: {
          title: "Orchit CMS | Package Categories",
        },
      },
      {
        path: "/currencies",
        name: "currencies",
        component: CurrenciesList,
        meta: {
          title: "Orchit CMS | Currencies",
        },
      },
      {
        path: "/packages",
        name: "packages",
        component: PackagesList,
        meta: {
          title: "Orchit CMS | Package Management",
        },
      },
      {
        path: "/paid-subscriptions",
        name: "paid-subscriptions",
        component: PaidSubscriptions,
        meta: {
          title: "Orchit CMS | Subscription Management",
        },
      },
      {
        path: "/free-subscriptions",
        name: "free-subscriptions",
        component: FreeSubscriptions,
        meta: {
          title: "Orchit CMS | Subscription Management",
        },
      },
      {
        path: "/marketplace-categories",
        name: "marketplace-categories",
        component:MarketplaceCategoriesList,
        meta: {
          title: "Orchit CMS |  marketplace Categories List",
        },
      },
      {
        path: "/admin/agents",
        name: "agents-list",
        component: AgentsList,
        meta: {
          title: "Orchit CMS | Agents Management",
        },
      },
      {
        path: "/admin/agents/new",
        name: "agents-create",
        component: AgentForm,
        meta: {
          title: "Orchit CMS | Create Agent",
        },
      },
      {
        path: "/admin/agents/:id/edit",
        name: "agents-edit",
        component: AgentForm,
        meta: {
          title: "Orchit CMS | Edit Agent",
        },
      },
      {
        path: "/admin/agents/:id",
        name: "agents-details",
        component: AgentDetails,
        meta: {
          title: "Orchit CMS | Agent Details",
        },
      },
      {
        path: "/admin/agent-capabilities",
        name: "agent-capabilities",
        component: AgentCapabilities,
        meta: {
          title: "Orchit CMS | Agent Capabilities",
        },
      },
      {
        path: "/admin/agent-roles",
        name: "agent-roles",
        component: AgentRoles,
        meta: {
          title: "Orchit CMS | Agent Roles",
        },
      },
      {
        path: "/admin/agent-competencies",
        name: "agent-competencies",
        component: AgentCompetencies,
        meta: {
          title: "Orchit CMS | Agent Competencies",
        },
      },
      {
        path: "/admin/agent-rules",
        name: "agent-rules",
        component: AgentRules,
        meta: {
          title: "Orchit CMS | Agent Rules",
        },
      },
      {
        path: "/admin/agent-skills",
        name: "agent-skills",
        component: AgentSkills,
        meta: {
          title: "Orchit CMS | Agent Skills",
        },
      },
      {
        path: "/admin/agent-levels",
        name: "agent-levels",
        component: AgentLevels,
        meta: {
          title: "Orchit CMS | Agent Levels",
        },
      },
      {
        path: "/admin/agent-actions",
        name: "agent-actions",
        component: AgentActions,
        meta: {
          title: "Orchit CMS | Agent Actions",
        },
      },
      {
        path: "/admin/agent-action-categories",
        name: "agent-action-categories",
        component: AgentActionCategories,
        meta: {
          title: "Orchit CMS | Agent Action Categories",
        },
      },
      {
        path: "/admin/knowledge-bases",
        name: "knowledge-bases-list",
        component: KnowledgeBasesList,
        meta: {
          title: "Orchit CMS | Knowledge Bases",
        },
      },
        {
        path: "/admin/kb-categories",
        name: "knowledge-bases-categores",
        component: KbCategories,
        meta: {
          title: "Orchit CMS | Knowledge Bases categories",
        },
      },
      {
        path: "/admin/knowledge-bases/new",
        name: "knowledge-bases-create",
        component: KnowledgeBaseForm,
        meta: {
          title: "Orchit CMS | Create Knowledge Base",
        },
      },
      {
        path: "/faqs",
        name: "Frequently Asked Questions",
        component: FAQS,
        meta: {
          title: "Orchit CMS | Frequently Asked Questions",
        },
      },
       {
        path: "/sitemap",
        name: "Sitemap",
        component: SiteMap,
        meta: {
          title: "Orchit CMS | SiteMap",
        },
      },
      {
        path: "/default-processes",
        name: "Default Processes",
        component: DefaultProcess,
        meta: {
          title: "Orchit CMS | Default Processes",
        },
      },
      {
        path: "/closed-tickets",
        name: "Closed Tickets",
        component: SupportTickets,
        props: { fixedStatus: "closed" },
        meta: {
          title: "Orchit CMS | Closed Tickets",
        },
      },
      {
        path: "/closed-tickets/:id",
        name: "Closed Support Ticket Detail",
        component: SupportTicketDetail,
        props: (route) => ({ id: route.params.id, readOnly: true }),
        meta: {
          title: "Orchit CMS | Closed Ticket Detail",
        },
      },
      {
        path: "/open-tickets",
        name: "Open Tickets",
        component: OpenTickets,
        meta: {
          title: "Orchit CMS | Support Tickets",
        },
      },
      {
        path: "/open-tickets/:id",
        name: "Open Ticket Detail",
        component: SupportTicketDetail,
        meta: {
          title: "Orchit CMS | Open Ticket Detail",
        },
        props: true,
      },
      {
        path: "/admin/knowledge-bases/:id/edit",
        name: "knowledge-bases-edit",
        component: KnowledgeBaseForm,
        meta: {
          title: "Orchit CMS | Edit Knowledge Base",
        },
      },
      {
        path: "/admin/knowledge-bases/:id",
        name: "knowledge-bases-details",
        component: KnowledgeBaseDetails,
        meta: {
          title: "Orchit CMS | Knowledge Base Details",
        },
      },
      {
        path: "/admin/companies",
        name: "companies-list",
        component: CompaniesList,
        meta: {
          title: "Orchit CMS | Companies Management",
        },
      },
      {
        path: "/admin/companies/:id",
        name: "company-details",
        component: CompanyDetails,
        meta: {
          title: "Orchit CMS | Company Details",
        },
      },
       {
        path: "/cms-users",
        name: "CMS User Management",
        component: CMSUsers,
        meta: {
          title: "Orchit CMS | CMS User Management",
        },
      },
       {
        path: "/cms-roles-permissions",
        name: "CMS Roles and Permissions",
        component: CMSRolesAndPermissions,
        meta: {
          title: "Orchit CMS | CMS Roles and Permissions",
        },
      },
        {
        path: "/permissions-module",
        name: "CMS Permissions Module",
        component: PermissionsModule,
        meta: {
          title: "Orchit CMS | CMS Permissions Module",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "lgin",
    component: loginPage,
    meta: {
      title: "Sign In | Orchit CMS",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((  
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    const isLoggedIn = !!localStorage.getItem("token"); // Fixed: use "token" instead of "token"
  
  console.log("🛡️ Router Guard:", {
    to: to.path,
    from: from.path,
    isLoggedIn,
    tokenExists: !!localStorage.getItem("token")
  });
  
  if (typeof to.meta.title === "string") {
    document.title = to.meta.title;
  }

  // Check if trying to access any login-related route
  const isLoginRoute = to.path === "/login" || to.path.includes("/auth/login");
  
  // Handle non-existent auth routes
  if (to.path.includes("/auth/") && to.path !== "/login") {
    console.log("⚠️ Invalid auth route detected, redirecting to proper route");
    if (isLoggedIn) {
      next({ path: "/" });
    } else {
      next({ path: "/login" });
    }
    return;
  }
  
  if (!isLoginRoute && !isLoggedIn) {
    console.log("❌ Not logged in, redirecting to login");
    next({ path: "/login", query: { redirect: to.fullPath } });
  }
  else if (isLoginRoute && isLoggedIn) {
    console.log("✅ Already logged in, redirecting away from login routes");
    next({ path: "/" });
  }
  else if (isLoginRoute && !isLoggedIn) {
    console.log("✅ Accessing login route while not logged in");
    next();
  }
  else {
    console.log("✅ Access granted to:", to.path);
    next();
  }
});

export default router;
